import React from 'react'
import { PropTypes } from 'prop-types'
import { CellUnits } from '../../../../components/Scheduler'
import addIcon from '~/assets/img/shift-to-open.svg';
import moment from 'moment';

function getCycleWeekNumber(cycleStartStr, cycleEndStr, cycleWeekLength, specificDateStr) {
    const cycleStart = moment(cycleStartStr, 'YYYY-MM-DD');
    const cycleEnd = moment(cycleEndStr, 'YYYY-MM-DD');
    const specificDate = moment(specificDateStr, 'YYYY-MM-DD');

    if (specificDate.isBefore(cycleStart)) return null;
    const cycleLengthDays = cycleEnd.diff(cycleStart, 'days') + 1;
    const daysSinceStart = specificDate.diff(cycleStart, 'days');
    const cycleNumber = Math.floor(daysSinceStart / cycleLengthDays);
    const currentCycleStart = cycleStart.clone().add(cycleNumber * cycleLengthDays, 'days');
    const dayWithinCycle = specificDate.diff(currentCycleStart, 'days');
    const daysPerWeek = Math.floor(cycleLengthDays / cycleWeekLength);
    const weekNumber = Math.floor(dayWithinCycle / daysPerWeek) + 1;
    return Math.min(weekNumber, cycleWeekLength) ?? '';
}


class HeaderView extends React.PureComponent {

    constructor(props) {
        super(props);
    }

    static propTypes = {
        schedulerData: PropTypes.object.isRequired,
        nonAgendaCellHeaderTemplateResolver: PropTypes.func,
    }



    getWeekDays = (startDate, endDate) => {
        const days = [];
        const start = this.props.schedulerData.localeMoment(startDate, 'DD.MM.YYYY');
        const end = this.props.schedulerData.localeMoment(endDate, 'DD.MM.YYYY');

        let current = start.clone();
        while (current.isSameOrBefore(end)) {
            days.push({
                dayName: current.format('dddd'),
                key: current.format('dddd').toLowerCase(),
                date: current.format('DD.MM.YYYY'),
                dayOfWeek: current.day()
            });
            current = current.add(1, 'days');
        }
        return days;
    }

    render() {
        const { schedulerData, nonAgendaCellHeaderTemplateResolver, showWeekHeaderAddIcon, t, dateTimeRules, departmentWiseCycleDetails, department } = this.props;
        const { cycle_start_date, cycle_end_date, cycle_week_length } = (department && departmentWiseCycleDetails && (department in departmentWiseCycleDetails)) ? departmentWiseCycleDetails[department] : {};
        const { headers, cellUnit, config, localeMoment } = schedulerData;
        let headerHeight = schedulerData.getTableHeaderHeight();
        let cellWidth = schedulerData.getContentCellWidth();
        let minuteStepsInHour = schedulerData.getMinuteStepsInHour();

        let headerList = [];
        let weekHeaderList = [];
        let currentWeek = null;

        let style = {};
        if (cellUnit === CellUnits.Hour) {
            headers.forEach((item, index) => {
                if (index % minuteStepsInHour === 0) {
                    let datetime = localeMoment(item.time);
                    const isCurrentTime = datetime.isSame(new Date(), 'hour');

                    style = !!item.nonWorkingTime ? { width: cellWidth * minuteStepsInHour, color: config.nonWorkingTimeHeadColor, backgroundColor: config.nonWorkingTimeHeadBgColor } : { width: cellWidth * minuteStepsInHour };

                    if (index === headers.length - minuteStepsInHour)
                        style = !!item.nonWorkingTime ? { color: config.nonWorkingTimeHeadColor, backgroundColor: config.nonWorkingTimeHeadBgColor } : {};

                    let pFormattedList = config.nonAgendaDayCellHeaderFormat.split('|').map(item => datetime.format(item));
                    let element;

                    if (typeof nonAgendaCellHeaderTemplateResolver === 'function') {
                        element = nonAgendaCellHeaderTemplateResolver(schedulerData, item, pFormattedList, style)
                    }
                    else {
                        const pList = pFormattedList.map((item, index) => (
                            <div key={index}>{(item)}</div>
                        ));

                        element = (
                            <th key={item.time} className="header3-text" style={style}>
                                <div>
                                    {pList}
                                </div>
                            </th>
                        );
                    }

                    headerList.push(element);
                }
            })
        }
        else {
            headerList = headers.map((item, index) => {
                let datetime = localeMoment(item.time);
                const isToday = localeMoment(new Date()).format('YYYY-MM-DD') === datetime.format('YYYY-MM-DD');
                const getDay = datetime.day()
                const isSatSun = getDay === 0 || getDay === 6
                const isHoliday = schedulerData.commonStore?.isHoliday(datetime.format('YYYY-MM-DD'));
                const holidayDetails = isHoliday ? schedulerData.commonStore?.getHolidayDetails(datetime.format('YYYY-MM-DD')) : null;
                const week = datetime.isoWeek();

                if (!currentWeek || currentWeek.week !== week) {

                    if (currentWeek) {
                        const endDate = localeMoment(headers[index - 1]?.time || headers[0].time).format('DD.MM.YYYY');
                        const weekData = {
                            week: currentWeek.week,
                            start: moment(currentWeek.start, 'DD.MM.YYYY').format('YYYY-MM-DD'),
                            end: moment(endDate, 'DD.MM.YYYY').format('YYYY-MM-DD'),
                            days: this.getWeekDays(currentWeek.start, endDate)
                        };
                        const getCycleWeek = getCycleWeekNumber(cycle_start_date, cycle_end_date, cycle_week_length, moment(weekData.start).format('YYYY-MM-DD'))


                        weekHeaderList.push(
                            <th
                                key={`week-${currentWeek.week}-${index}`}
                                colSpan={currentWeek.colspan}
                                title={`${t('Week')} ${weekData.week} (${moment(weekData.start).format(dateTimeRules.short_date_format)} | ${moment(weekData.end).format(dateTimeRules.short_date_format)}) ${department && getCycleWeek ? `(${t('Cycle')} ${t('Week')} ${getCycleWeek})` : null}`}
                                style={{
                                    textAlign: 'center',
                                    backgroundColor: 'rgba(188, 197, 201, 1)',
                                    fontWeight: 'bold',
                                    fontSize: '11px',
                                    overflow: 'hidden',
                                    whiteSpace: 'nowrap',
                                    textOverflow: 'ellipsis',
                                    maxWidth: '30px',
                                }}
                            >
                                {showWeekHeaderAddIcon && (
                                    <span
                                        className='mx-2'
                                        onClick={() => this.props.handleShowShiftCodeModal(weekData)}
                                    >
                                        <img src={addIcon} alt="Add shift code" />
                                    </span>
                                )}
                                {`${t('Week')} ${weekData.week} (${moment(weekData.start).format(dateTimeRules.short_date_format)} | ${moment(weekData.end).format(dateTimeRules.short_date_format)})`} {department && getCycleWeek ? `(${t('Cycle')} ${t('Week')} ${getCycleWeek})` : null}
                            </th>
                        );
                    }

                    currentWeek = {
                        week,
                        start: datetime.format('DD.MM.YYYY'),
                        colspan: 1
                    };
                } else {
                    currentWeek.colspan += 1;
                }

                style = isSatSun ? { width: cellWidth, color: config.nonWorkingTimeHeadColor, backgroundColor: config.nonWorkingTimeHeadBgColor } : { width: cellWidth };
                if (index === headers.length - 1)
                    style = isSatSun ? { color: config.nonWorkingTimeHeadColor, backgroundColor: config.nonWorkingTimeHeadBgColor } : {};

                let pFormattedList = config.nonAgendaOtherCellHeaderFormat.split('|').map(item => {
                    const trimmed = item.trim();
                    if (trimmed === 'ddd') {
                        const dayAbbr = datetime.format('ddd');
                        return t(dayAbbr) + ' ';
                    }
                    return datetime.format(item);
                });

                if (typeof nonAgendaCellHeaderTemplateResolver === 'function') {
                    return nonAgendaCellHeaderTemplateResolver(schedulerData, item, pFormattedList, style)
                }

                const pList = pFormattedList.map((item, index) => (
                    <div key={index}>{t(item)}</div>
                ));

                return (
                    <th key={item.time} className="header3-text" title={isHoliday ? (holidayDetails?.custom_name || holidayDetails?.name) : null} style={{ ...style, backgroundColor: isToday ? '#2550ac' : isHoliday ? '#FFE4B5' : 'rgba(188, 197, 201, 1)' }}>
                        <div>
                            <div style={{ padding: '4px' }}>
                                <div style={{
                                    backgroundColor: isSatSun ? 'red' : isHoliday ? '#FFA500' : 'white',
                                    color: (isSatSun || isHoliday) ? 'white' : 'black',
                                    borderRadius: '12px',
                                    fontSize: '10px',
                                    fontWeight: 'bold',
                                    height: '35px'
                                }}>

                                    {pList}
                                </div>
                            </div>
                        </div>
                    </th>
                );
            });

            if (currentWeek) {
                const endDate = localeMoment(headers[headers.length - 1]?.time || headers[0].time).format('DD.MM.YYYY');
                const lastWeekData = {
                    week: currentWeek.week,
                    start: moment(currentWeek.start, 'DD.MM.YYYY').format('YYYY-MM-DD'),
                    end: moment(endDate, 'DD.MM.YYYY').format('YYYY-MM-DD'),
                    days: this.getWeekDays(currentWeek.start, endDate)
                };
                const getCycleWeek = getCycleWeekNumber(cycle_start_date, cycle_end_date, cycle_week_length, moment(lastWeekData.start).format('YYYY-MM-DD'))
                weekHeaderList.push(
                    <th
                        key={`week-${lastWeekData.week}-last`}
                        colSpan={currentWeek.colspan}
                        title={`${t('Week')} ${lastWeekData.week} (${moment(lastWeekData.start, 'YYYY-MM-DD').format(dateTimeRules.short_date_format)} | ${moment(lastWeekData.end, 'YYYY-MM-DD').format(dateTimeRules.short_date_format)})`}
                        style={{
                            textAlign: 'center',
                            backgroundColor: 'rgba(188, 197, 201, 1)',
                            fontWeight: 'bold',
                            fontSize: '11px',
                            overflow: 'hidden',
                            whiteSpace: 'nowrap',
                            textOverflow: 'ellipsis',
                            maxWidth: '30px'
                        }}
                    >
                        {showWeekHeaderAddIcon && (
                            <span
                                className='mx-2'
                                onClick={() => this.props.handleShowShiftCodeModal(lastWeekData)}
                            >
                                <img src={addIcon} alt="Add shift code" />
                            </span>
                        )}
                        {`${t('Week')} ${lastWeekData.week} (${moment(lastWeekData.start).format(dateTimeRules.short_date_format)} | ${moment(lastWeekData.end).format(dateTimeRules.short_date_format)})`} {department && getCycleWeek ? `(${t('Cycle')} ${t('Week')} ${getCycleWeek})` : null}
                        {/* {`${t('Week')} ${lastWeekData.week} (${moment(lastWeekData.start, 'YYYY-MM-DD').format(dateTimeRules.short_date_format)} | ${moment(lastWeekData.end, 'YYYY-MM-DD').format(dateTimeRules.short_date_format)})`} */}
                    </th>
                );
            }
        }

        return (
            <thead style={{ height: headerHeight }}>
                <tr style={{ height: 25, lineHeight: '13px' }}>
                    {weekHeaderList}
                </tr>
                <tr>
                    {headerList}
                </tr>
            </thead>
        );
    }
}

export default HeaderView;
